export const removeLastHyphen = (location: string | undefined | null) => {
  if (!location) return '-'
  if (location.endsWith('-')) {
    return location.slice(0, -1)
  }
  return location
}
